define(['angular', 'lodash'], function(angular, lodash) {


    /**
     * @class LadditionService
     */
    function LadditionService(pricesService, userService) {
        var self = this;

        /* ======= Options references ======= */

        // Options those automatically included with each type of license
        var LICENSE_OPTIONS = {
            MONO: ['LICMONO', 'MAINT', 'ROUTSTD', 'MES'],
            MULTI: ['LICMULTI', 'MAINT', 'LADDITIONSERVER', 'ROUTSTD', 'MES']
        };

        // Options linked to the number of devices
        var MULTIDEVICES_OPTIONS = ['LICMULTI', 'MAINT'];

        // Devices Options
        var DEVICE_OPTIONS = ['iPad', 'iPadMini', 'iPod', 'iPadPro'];

        /* Functions */

        /**
         * Find the included options from LICENSE_OPTIONS according to the license type
         * @param  {String} type license type 'MONO' or 'MULTI'
         * @param  {Array} options array with all options (from the order form)
         * @return {Array} options included with the license
         */
        self.getLicenseIncludedOptions = function getLicenseIncludedOptions(type, options) {
            return LICENSE_OPTIONS[type.code].map(function(optionReference) {
                return options.find(function(option) {
                    return option.reference === optionReference;
                });
            });
        };

        /**
         * Return pack options with the correct nbOptions
         * @param {Array} options
         * @param {String} type  License type
         * @param {Number} licensesNumber
         * @return {Array} packOptions
         */
        self.setPackIncludedOptions = function setPackIncludedOptions(options, type, licensesNumber) {
            var packOptions = self.getLicenseIncludedOptions(type, options);
            packOptions.forEach(function(option) {
                option.nbOptions = self.isOptionMultiDevice(option) && type === 'MULTI' ? licensesNumber : 1;
            });
            return packOptions;
        };

        /**
         * Update maximum discount amount according to the given license type and the user rights
         * @param  {String} type
         * @param  {Object} user
         * @return {Number} Maximum discount percentage allowed
         */
        self.updateMaxDiscount = function updateMaxDiscount(type, user) {
            if (userService.isSalesRep(user)) {
                // Standard discount allowed for RDS, telepros and CUP
                return type.code === 'MONO' ? 5 : type.code === 'MULTI' ? 10 : 0;
            }
            else if (userService.isGroupMember(user, 'DRV')) {
                // Double of the standard discount allowed for DRV
                return type.code === 'MONO' ? 10 : type.code === 'MULTI' ? 20 : 0;
            }
            else if (userService.isSalesAdmin(user)) {
                // no limit on discount for Sales Admin
                return 100;
            }
            else {
                return 0;
            }
        };

        /**
         * Check if the option is concerned by the number of devices selected
         * @param  {Object}  option
         * @return {Boolean}
         */
        self.isOptionMultiDevice = function isOptionMultiDevice(option) {
            return MULTIDEVICES_OPTIONS.indexOf(option.reference) !== -1;
        };

        /**
         * Filter l'addition options using their optionType prefix
         * @param  {Array} options
         * @return {Array} Filtered array containing l'addition options
         */
        self.getLadditionOptions = function getLadditionOptions(options) {
            return options.filter(function(option) {
                return option.isDeleted === false && option.optionType.code.indexOf('LADDITION_', 0) === 0;
            });
        };

        /**
         * Check for required attributes on laddition object
         * @param  {Object}  laddition
         * @return {Boolean}
         */
        self.isOfferDefined = function isOfferDefined(laddition) {
            return laddition.licenseType.code && laddition.contractType && laddition.dateInstallation;
        };

        self.getOfferNotDefinedMessage = function getOfferNotDefinedMessage(laddition) {
            if (!laddition.contractType.code) {
                return 'Veuillez définir le type de contrat.';
            }

            if (!laddition.licenseType.code) {
                return 'Veuillez définir le type de licence.';
            }

            if (!laddition.dateInstallation) {
                return "Veuillez définir le mois d'installation.";
            }

            return '';
        };

        /**
         * Returns total rental and purchase prices of the addition offer according to laddition object and offer business rules.
         * @param  {Object} laddition
         * @return {Object} total prices {rental:{total, discount, actual},purchase: {total, discount, actual}} with keys: 'total' for price before discount, 'discount' and 'actual' for the real price after discount
         */
        self.calculateLadditionPrice = function calculateLadditionPrice(laddition) {
            var prices = {
                rental: {
                    total: 0,
                    discount: 0,
                    actual: 0
                },
                purchase: {
                    total: 0,
                    discount: 0,
                    actual: 0
                }
            };
            if (!laddition.contractType.code) {
                return prices;
            }

            var discount = laddition.discount ? laddition.discount : 0;

            // We filter out LADDITION_FRAIS options because they will be added at the end after the discount has been applied
            var options = _.groupBy(laddition.options, function(option) {
                return option.optionType.code !== 'LADDITION_FRAIS';
            });

            // We need to split options between purchase and rental prices.
            if (laddition.contractType.code === 'ACHAT') {
                var optionsGroups = _.groupBy(options.true, function(option) {
                    return option.optionType.code === 'LADDITION_TPE' || option.reference === 'MAINT'; // Filter on rental only prices.Those options will be put in optionsGroups.true
                });
            }
            else {
                var optionsGroups = _.groupBy(options.true, function(option) {
                    return option.reference !== 'TPECABLE'; // Filter on purchase only prices options
                });
            }

            var groupedPrices = {};
            groupedPrices.rental = (optionsGroups.true || []).map(function(option) {
                return pricesService.getUnitPrice(option.prices, laddition.contractType.code).value * option.nbOptions;
            });
            groupedPrices.purchase = (optionsGroups.false || []).map(function(option) {
                return pricesService.getUnitPrice(option.prices, laddition.contractType.code).value * option.nbOptions;
            });
            var feesPrices = (options.false || []).map(function(option) {
                return pricesService.getUnitPrice(option.prices, laddition.contractType.code).value * option.nbOptions;
            });

            // Sum and calculate all total prices
            prices.rental.total = pricesService.sumPrices(groupedPrices.rental, 0);
            prices.rental.discount = pricesService.calculateDiscount(prices.rental.total, discount);
            prices.rental.actual =
                pricesService.sumPrices(groupedPrices.rental, 0) * pricesService.applyDiscountRate(discount);

            prices.purchase.total = pricesService.sumPrices(groupedPrices.purchase, 0);
            prices.purchase.discount = pricesService.calculateDiscount(prices.purchase.total, discount);
            prices.purchase.actual =
                pricesService.sumPrices(groupedPrices.purchase, 0) * pricesService.applyDiscountRate(discount);

            if (laddition.contractType.code === 'ACHAT') {
                prices.purchase.actual += pricesService.sumPrices(feesPrices, 0);
            }
            else {
                prices.rental.actual += pricesService.sumPrices(feesPrices, 0);
            }

            return prices;
        };

        /**
         * Get the amount of device included in a given option array
         * @param  {Array} options
         * @return {Number}
         */
        self.getDeviceAmount = function getDeviceAmount(options) {
            if (options.length === 0) {
                return 0;
            }
            var amount = 0;
            options.forEach(function(option) {
                if (_.contains(DEVICE_OPTIONS, option.reference)) {
                    amount += option.nbOptions;
                }
            });

            return amount;
        };

        self.getFees = function getFees(options) {
            return options.filter(function(option) {
                return option.optionType.code === 'LADDITION_FRAIS';
            });
        };

        return self;
    }

    LadditionService.$inject = ['pricesService', 'userService'];

    angular.module('app.bdc.common.ladditionService', []).factory('ladditionService', LadditionService);
});
